import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';
export const GET_ALL_PRODUCTTYPES = 'GET_ALL_PRODUCTTYPES';
export const SAVE_PRODUCTTYPE = 'SAVE_PRODUCTTYPE';
export const DELETE_PRODUCTTYPE = 'DELETE_PRODUCTTYPE';

const successColor = 'success';
const errorColor = 'danger';
//const warningPRODUCTTYPE = 'warning';

export function fetchAllProductTypes() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageProductType/GetProductTypes`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_ALL_PRODUCTTYPES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function saveProductType(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageProductType/SaveProductType`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: SAVE_PRODUCTTYPE,
						payload: response.data.productTypes
					});
					var success = response && response.data ? response.data.message : 'ProductType Created Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteProductType(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageProductType/DeleteProductType`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
				dispatch({
					type: DELETE_PRODUCTTYPE,
					payload: response.data.productTypes
				});
				var success = response && response.data ? response.data.message : 'ProductType Deleted Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
